import React from "react";

const Footer = () => (
  <footer>
    <div className="container">
      <div className="row">
        <div className="col-md-6">
          <div className="social">
            <a href="https://www.instagram.com/LifeatShopee" target="_blank" rel="noopener noreferrer">Instagram</a>
            <a href="https://linkedin.com/company/Shopee" target="_blank" rel="noopener noreferrer">LinkedIn</a>
            <a href="https://careers.shopee.sg/" target="_blank" rel="noopener noreferrer">Career</a>
          </div>
        </div>
        <div className="col-md-6">
          <p className="copyright">&copy; 2018-2019 Shopee All rights reserved.</p>
        </div>
      </div>
    </div>
  </footer>
);

export default Footer;